module.exports = __webpack_public_path__ + "static/img/bathtub.0d5b5c34.png";